import * as React from 'react';

const SOURCE_KEY = 'my_home_source';

export const useSaveSource = () => {
  React.useEffect(() => {
    try {
      let source = new URLSearchParams(window.location.search).get('from');

      if (!source) {
        const cookieSource = document.cookie
          .split(';')
          .map(cookie => cookie.trim())
          .find(cookie => cookie.startsWith(`${SOURCE_KEY}=`))
          ?.slice(SOURCE_KEY.length + 1);

        source = cookieSource ? decodeURIComponent(cookieSource) : null;
      }

      if (source) {
        localStorage.setItem(SOURCE_KEY, source);
      }
    } catch {
      return;
    }
  }, []);
};
